<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 pt-2 px-2 pb-0">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
          <label class="d-flex align-items-center">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" autocomplete="off" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filterBanks()" />
          </label>
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'w-fit d-inline-block mr-2'" [ngClass.md]="'w-fit d-inline-block mr-2'" [ngClass.sm]="'d-none'">
            <label class="d-flex align-items-center"
            >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" #tableLimitSelect (change)="updateTableLimit(tableLimitSelect.value)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a (click)="modalOpen(bankAdd, null)" class="btn btn-outline-primary text-primary" *ngIf="_authenticationService.hasCapability('create_bank')">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 50 : 170"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="filteredBanksList"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'IBAN' | translate" prop="other.iban" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.iban }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="('BIC' | translate) + '/' + ('SWIFT' | translate)" prop="other.bic" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.bic }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'NOTES' | translate" prop="other.note" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="cursor-pointer" *ngIf="row.other.note" [ngbTooltip]="'VIEW_NOTES' | translate" (click)="modalOpen(modalNote, null, row.other.note)">
                <i [size]="'19'" [data-feather]="'file-text'"></i>
              </span>
              <span *ngIf="!row.other.note || row.other.note === ''">-</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" width="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button (click)="modalOpen(bankEdit, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_bank')">
                  <i [data-feather]="'eye'" size="19"></i>
                </button>
                <button (click)="modalOpen(bankEdit, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_bank')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteBank(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_bank')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [width]="null" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <span class="font-weight-bold">{{ "NAME" | translate }}: </span>
                  <span>{{ row.name }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "IBAN" | translate }}: </span>
                  <span>{{ row.other.iban }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "BIC" | translate }}/{{ "SWIFT" | translate }}: </span>
                  <span>{{ row.other.bic }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "NOTES" | translate }}: </span>
                  <span class="cursor-pointer" *ngIf="row.other.note" [ngbTooltip]="'VIEW_NOTES' | translate" (click)="modalOpen(modalNote, null, row.other.note)">
                    <i [size]="'19'" [data-feather]="'file-text'"></i>
                  </span>
                  <span *ngIf="!row.other.note || row.other.note === ''">-</span>
                </div>
                <div class="col-12 mt-075 text-right" [ngClass.md]="'pr-2'">
                  <button (click)="modalOpen(bankEdit, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_bank')">
                    <i [data-feather]="'eye'" size="19"></i>
                  </button>
                  <button (click)="modalOpen(bankEdit, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_bank')">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button (click)="deleteBank(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_bank')">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
<!-- Modal Add -->
<ng-template #bankAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD_NEW_BANK" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="bankForm.name" name="name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!bankForm.name || bankForm.name.length < 1)">{{ "ERRORS.INSERT_NAME" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'iban'">{{ "IBAN" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="bankForm.other.iban" name="iban" type="text" [id]="'iban'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!bankForm.other.iban || bankForm.other.iban.length < 1)">{{ "ERRORS.INSERT_IBAN" | translate }}</div>
        <div class="font-error" *ngIf="!!bankForm.other.iban && bankForm.other.iban.length < 15">{{ "ERRORS.MIN_IBAN" | translate }}</div>
        <div class="font-error" *ngIf="!!bankForm.other.iban && bankForm.other.iban.length > 36">{{ "ERRORS.MAX_IBAN" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'bic'">{{ "BIC" | translate }}/{{ "SWIFT" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="bankForm.other.bic" name="bic" type="text" [id]="'bic'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!bankForm.other.bic || bankForm.other.bic.length < 1)">{{ "ERRORS.INSERT_BIC_SWIFT" | translate }}</div>
        <div class="font-error" *ngIf="!!bankForm.other.bic && bankForm.other.bic.length < 8">{{ "ERRORS.MIN_BIC_SWIFT" | translate }}</div>
        <div class="font-error" *ngIf="!!bankForm.other.bic && bankForm.other.bic.length > 11">{{ "ERRORS.MAX_BIC_SWIFT" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'note'">{{ "NOTES" | translate }}</label>
        <textarea [(ngModel)]="bankForm.other.note" name="note" type="text" [id]="'note'" class="form-control"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="addBank()">
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Add -->

<!-- Modal Edit -->
<ng-template #bankEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT_BANK" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="bankForm.name" name="name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!bankForm.name || bankForm.name.length < 1)">{{ "ERRORS.INSERT_NAME" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'iban'">{{ "IBAN" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="bankForm.other.iban" name="iban" type="text" [id]="'iban'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!bankForm.other.iban || bankForm.other.iban.length < 1)">{{ "ERRORS.INSERT_IBAN" | translate }}</div>
        <div class="font-error" *ngIf="!!bankForm.other.iban && bankForm.other.iban.length < 15">{{ "ERRORS.MIN_IBAN" | translate }}</div>
        <div class="font-error" *ngIf="!!bankForm.other.iban && bankForm.other.iban.length > 36">{{ "ERRORS.MAX_IBAN" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'bic'">{{ "BIC" | translate }}/{{ "SWIFT" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="bankForm.other.bic" name="bic" type="text" [id]="'bic'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!bankForm.other.bic || bankForm.other.bic.length < 1)">{{ "ERRORS.INSERT_BIC_SWIFT" | translate }}</div>
        <div class="font-error" *ngIf="!!bankForm.other.bic && bankForm.other.bic.length < 8">{{ "ERRORS.MIN_BIC_SWIFT" | translate }}</div>
        <div class="font-error" *ngIf="!!bankForm.other.bic && bankForm.other.bic.length > 11">{{ "ERRORS.MAX_BIC_SWIFT" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'note'">{{ "NOTES" | translate }}</label>
        <textarea [(ngModel)]="bankForm.other.note" name="note" type="text" [id]="'note'" class="form-control"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="editBank()">
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Notes -->
<ng-template #modalNote let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "NOTES" | translate }}</h3>
    <div class="row">
      <div class="col-12">
        {{ selectedNote }}
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CLOSE" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Notes -->
